{
  "common": {
    "appName": "Aimly Admin",
    "loading": "Loading…",
    "retry": "Retry",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "prev": "Previous",
    "next": "Next",
    "page": "{{page}} / {{total}}",
    "total": "Total: {{count}}",
    "all": "All",
    "yes": "Yes",
    "no": "No",
    "back": "Back",
    "logout": "Log out",
    "language": "Language",
    "theme": "Theme",
    "loadError": "Couldn't load the data."
  },
  "nav": {
    "users": "Users",
    "deliveries": "Deliveries",
    "announcements": "Announcements",
    "sectionManage": "Manage",
    "menu": "Menu",
    "dashboard": "Dashboard"
  },
  "auth": {
    "title": "Admin sign in",
    "subtitle": "Sign in with Telegram. Only allowed admins can get in.",
    "botButton": "Sign in with the Telegram bot",
    "waiting": "Press «Start» in the bot and confirm. This page updates by itself.",
    "openAgain": "Open the bot again",
    "expired": "The sign-in link has expired. Start again.",
    "devTitle": "Test sign in (dev only)",
    "devPlaceholder": "Telegram id",
    "devButton": "Sign in",
    "notConfigured": "Telegram sign in isn't configured yet.",
    "checking": "Checking your session…",
    "forbiddenTitle": "No access",
    "forbiddenText": "This Telegram account isn't on the admin list. Add your Telegram id to ADMIN_TELEGRAM_IDS on the backend.",
    "yourId": "Your Telegram id: {{id}}",
    "otherAccount": "Sign in with another account"
  },
  "overview": {
    "delivered": "Delivered",
    "failed": "Failed",
    "pending": "Queued",
    "successRate": "Success: {{percent}}%",
    "noDeliveries": "Nothing has been sent on this channel yet.",
    "failedLink": "View failures"
  },
  "users": {
    "title": "Users",
    "subtitle": "Search, check status and block",
    "name": "User",
    "tasks": "Tasks",
    "goals": "Goals",
    "telegram": "Telegram",
    "lastLogin": "Last sign in",
    "joined": "Joined",
    "status": "Status",
    "active": "Active",
    "blocked": "Blocked",
    "admin": "Admin",
    "reachable": "Reachable",
    "unreachable": "Blocked the bot",
    "emptyTitle": "No users found",
    "emptyText": "Shorten the search or switch the filter back to «All».",
    "emptyNoUsers": "Nobody has signed up yet. The first user shows up here after pressing /start in the bot.",
    "open": "Open {{name}}",
    "language": "Language",
    "lastActive": "Last active",
    "activityActive": "Active (7 days)",
    "activityInactive": "Inactive",
    "activeToday": "today",
    "daysAgo": "{{count}}d ago",
    "neverActive": "never"
  },
  "user": {
    "notFound": "User not found.",
    "profile": "Profile",
    "activity": "Activity",
    "schedule": "Reminder times",
    "language": "Language",
    "timezone": "Time zone",
    "morning": "Morning plan",
    "planning": "Plan tomorrow",
    "review": "Daily review",
    "tasks": "Tasks",
    "completed": "Completed",
    "completed7d": "Completed (7 days)",
    "goals": "Goals",
    "dailyReviews": "Daily reviews",
    "weeklyReviews": "Weekly reviews",
    "failedDeliveries": "Telegram failures",
    "telegramId": "Telegram id",
    "block": "Block",
    "unblock": "Unblock",
    "blockTitle": "Block this user?",
    "blockText": "{{name}} will be signed out everywhere, won't be able to sign in and won't get notifications. Their data is kept.",
    "unblockTitle": "Unblock this user?",
    "unblockText": "{{name}} will be able to sign in again and notifications resume.",
    "blocked": "User blocked.",
    "unblocked": "User unblocked.",
    "adminNote": "Admin accounts can't be blocked.",
    "sendMessage": "Send a message",
    "notFoundText": "The link is outdated or the account was removed. Try searching the list.",
    "completed7dHint": "This week: {{count}}",
    "sections": "User sections",
    "tabs": {
      "stats": "Statistics",
      "activity": "Activity log",
      "profile": "Profile"
    }
  },
  "deliveries": {
    "title": "Deliveries",
    "subtitle": "Web and Telegram notification status",
    "status": "Status",
    "channel": "Channel",
    "type": "Type",
    "recipient": "Recipient",
    "attempts": "Attempts",
    "created": "Created",
    "sentAt": "Sent",
    "error": "Error",
    "retry": "Resend",
    "retried": "Resent: {{status}}",
    "emptyTitle": "No deliveries found",
    "emptyText": "Nothing matches the selected filter. Switch it back to «All».",
    "statuses": {
      "PENDING": "Queued",
      "SENT": "Sent",
      "FAILED": "Failed",
      "READ": "Read",
      "SKIPPED": "Skipped"
    },
    "channels": {
      "WEB": "Web",
      "TELEGRAM": "Telegram"
    },
    "types": {
      "DAILY_PLAN": "Daily plan",
      "PLANNING_REMINDER": "Planning reminder",
      "TASK_REMINDER": "Task reminder",
      "TASK_OVERDUE": "Overdue task",
      "TASK_POSTPONED": "Postponed task",
      "DAILY_REVIEW": "Daily review",
      "WEEKLY_REVIEW": "Weekly review",
      "SYSTEM": "Announcement"
    }
  },
  "announcements": {
    "title": "Announcements",
    "subtitle": "Message users on Web and Telegram",
    "new": "New announcement",
    "formTitle": "Title",
    "formBody": "Message",
    "target": "Send to",
    "targetAll": "All active users",
    "targetOne": "A single user",
    "targetId": "Telegram id",
    "send": "Send",
    "confirmTitle": "Send this announcement?",
    "confirmAll": "The message goes to every active user. This can't be undone.",
    "confirmOne": "The message goes to the owner of Telegram id {{id}}.",
    "sent": "Announcement sent to {{count}} recipients.",
    "history": "Sent",
    "toAll": "Everyone",
    "toOne": "Single user",
    "emptyTitle": "No announcements yet",
    "emptyText": "Use the form on the left to tell users about a new feature or maintenance.",
    "hint": "In Telegram it arrives as «📣 title»; users who turned notifications off see it on Web only.",
    "validation": {
      "title": "Title must be 1–200 characters.",
      "body": "Message must be 1–2000 characters.",
      "telegramId": "Telegram id must contain digits only."
    },
    "preview": "How it looks in Telegram",
    "recipientsColumn": "Recipients",
    "sentAt": "Sent"
  },
  "notFound": {
    "title": "Page not found",
    "action": "Go home",
    "text": "The address is wrong or the page has moved. Pick a section from the menu."
  },
  "errors": {
    "UNKNOWN_ERROR": "Something went wrong. Please try again.",
    "NETWORK_ERROR": "Can't reach the server. Check your connection.",
    "INTERNAL_ERROR": "Server error. Please try again shortly.",
    "VALIDATION_FAILED": "Some fields are invalid.",
    "NOT_FOUND": "Not found.",
    "FORBIDDEN": "Access denied.",
    "RATE_LIMITED": "Too many attempts. Try again in a minute.",
    "NO_TOKEN": "Please sign in.",
    "TOKEN_EXPIRED": "Your session expired.",
    "TOKEN_INVALID": "Session is invalid. Sign in again.",
    "TOKEN_STALE": "Session was closed. Sign in again.",
    "AUTH_FAILED": "Couldn't sign in. Please try again.",
    "ACCOUNT_BLOCKED": "Account is blocked.",
    "REFRESH_TOKEN_INVALID": "Session ended. Sign in again.",
    "REFRESH_TOKEN_REUSED": "Session closed for security. Sign in again.",
    "TELEGRAM_NOT_CONFIGURED": "Telegram sign in isn't configured yet.",
    "LOGIN_REQUEST_NOT_FOUND": "Sign-in request not found or already used. Start again.",
    "LOGIN_REQUEST_EXPIRED": "The sign-in link has expired. Start again.",
    "DEV_LOGIN_DISABLED": "Test sign in is disabled.",
    "USER_NOT_FOUND": "User not found.",
    "ADMIN_ONLY": "This area is for admins only.",
    "CANNOT_BLOCK_ADMIN": "Admin accounts can't be blocked.",
    "DELIVERY_NOT_FOUND": "Delivery not found.",
    "DELIVERY_NOT_RETRYABLE": "Only failed deliveries can be resent."
  },
  "table": {
    "search": "Search…",
    "clear": "Clear",
    "clearAll": "Clear all",
    "filterBy": "Filter by {{column}}",
    "removeFilter": "Remove {{column}} filter",
    "sortBy": "Sort by {{column}}",
    "sortedAsc": "{{column}}: ascending",
    "sortedDesc": "{{column}}: descending",
    "columns": "Columns",
    "columnsHint": "Visible columns",
    "showAll": "Show all",
    "hiddenCount": "{{count}} hidden",
    "rowsPerPage": "Rows per page",
    "range": "{{from}}–{{to}}",
    "of": "of {{total}}",
    "pages": "Pages",
    "goToPage": "Page {{page}}"
  },
  "dashboard": {
    "title": "Dashboard",
    "subtitle": "How Aimly is doing — at a glance.",
    "greeting": "Welcome back, {{name}}! Every metric for the selected period is here.",
    "presets": {
      "today": "Today",
      "7d": "7 days",
      "30d": "30 days",
      "90d": "90 days",
      "year": "Year"
    },
    "filters": {
      "period": "Period",
      "from": "Start date",
      "to": "End date",
      "language": "Users' language",
      "allLanguages": "All languages",
      "channel": "Channel",
      "allChannels": "All channels",
      "activeWindow": "Active window",
      "activeDays": "Active: {{count}}d",
      "reset": "Reset filters"
    },
    "deltaNew": "new",
    "deltaPoints": "{{value}} pt",
    "deltaHint": "Previous period: {{value}}",
    "hoursMinutes": "{{hours}}h {{minutes}}m",
    "weekdays": "Mon,Tue,Wed,Thu,Fri,Sat,Sun",
    "activity": {
      "title": "User activity",
      "subtitle": "Active — signed in or did something in the last {{count}} days",
      "active": "Active",
      "inactive": "Inactive",
      "activeShare": "active",
      "dau": "DAU",
      "wau": "WAU",
      "mau": "MAU",
      "stickiness": "Stickiness",
      "stickinessHint": "DAU / MAU: how often people come back"
    },
    "users": {
      "total": "Total users",
      "new": "New",
      "atRisk": "At risk",
      "atRiskHint": "Active the previous {{count}} days, not now",
      "never": "Never activated",
      "neverHint": "Never created a task",
      "reachable": "Bot can message",
      "blocked": "Blocked"
    },
    "series": {
      "title": "Trends",
      "activeUsers": "Active",
      "signups": "Sign-ups",
      "tasksCreated": "Tasks created",
      "tasksCompleted": "Tasks completed",
      "inPeriod": "in period",
      "bucket": {
        "day": "By day",
        "week": "By week",
        "month": "By month"
      }
    },
    "tasks": {
      "created": "Created",
      "completed": "Completed",
      "rate": "Completion",
      "rateHint": "Planned: {{count}}",
      "postponed": "Postponed",
      "cancelled": "Cancelled",
      "focus": "Focus time",
      "focusHint": "Actual time on completed tasks"
    },
    "clock": {
      "title": "When people work",
      "hours": "Completions by hour",
      "weekdays": "By weekday",
      "peak": "Peak hour — {{hour}}:00",
      "empty": "No completed tasks in this period."
    },
    "funnel": {
      "title": "Activation funnel",
      "subtitle": "How far new sign-ups got",
      "registered": "Signed up",
      "createdTask": "Created a task",
      "completedTask": "Completed a task",
      "wroteReview": "Wrote a review",
      "empty": "No sign-ups in this period — widen the range."
    },
    "top": {
      "title": "Top users",
      "subtitle": "Completed / planned",
      "empty": "Nobody completed a task in this period."
    },
    "goals": {
      "title": "Goals & reviews",
      "created": "Goals created",
      "completed": "Goals reached",
      "active": "Active goals"
    },
    "reviews": {
      "daily": "Daily reviews",
      "weekly": "Weekly reviews",
      "period": "Monthly/yearly"
    },
    "languages": {
      "title": "Languages",
      "subtitle": "All users"
    },
    "deliveries": "Notification delivery",
    "hoursOnly": "{{hours}}h"
  },
  "userStats": {
    "period": "Period",
    "periods": {
      "day": "Day",
      "week": "Week",
      "month": "Month",
      "year": "Year"
    },
    "prev": "Previous period",
    "next": "Next period",
    "today": "Today",
    "planned": "Planned",
    "completed": "Completed",
    "rate": "Completion",
    "focus": "Focus time",
    "postponed": "Postponed",
    "cancelled": "Cancelled",
    "activeDays": "Active days",
    "logins": "Sign-ins",
    "chart": "Planned vs completed",
    "chartHours": "By hour",
    "legend": "Light bar — planned, dark — completed",
    "legendHours": "Light — created, dark — completed",
    "priority": "By priority",
    "priorities": {
      "HIGH": "High",
      "MEDIUM": "Medium",
      "LOW": "Low"
    },
    "goalsCreated": "Goals",
    "goalsCompleted": "Reached",
    "reviews": "Reviews",
    "calendar": "Activity calendar",
    "calendarHint": "Last year; click a day to open its statistics",
    "calendarSummary": "{{days}} active days, {{total}} actions",
    "calendarCell": "{{date}}: {{count}} actions",
    "less": "Less",
    "more": "More"
  },
  "activity": {
    "at": "Time",
    "event": "Action",
    "object": "Object",
    "detail": "Details",
    "forDate": "date: {{date}}",
    "unknownDevice": "Unknown device",
    "emptyTitle": "No activity",
    "emptyText": "Nothing yet: the first sign-in or task will show up here.",
    "emptyFiltered": "No actions of this kind — remove the filter.",
    "groups": {
      "session": "Sign-ins",
      "task": "Tasks",
      "goal": "Goals",
      "review": "Reviews",
      "notification": "Notifications"
    },
    "types": {
      "LOGIN": "Signed in",
      "TASK_CREATED": "Created a task",
      "TASK_COMPLETED": "Completed a task",
      "TASK_POSTPONED": "Postponed a task",
      "TASK_CANCELLED": "Cancelled a task",
      "GOAL_CREATED": "Set a goal",
      "GOAL_COMPLETED": "Reached a goal",
      "GOAL_ARCHIVED": "Archived a goal",
      "DAILY_REVIEW": "Wrote a daily review",
      "WEEKLY_REVIEW": "Wrote a weekly review",
      "PERIOD_REVIEW": "Wrote a period review",
      "NOTIFICATION_READ": "Read a notification"
    },
    "goalTypes": {
      "YEAR": "yearly goal",
      "QUARTER": "quarterly goal",
      "MONTH": "monthly goal",
      "WEEK": "weekly goal"
    },
    "periods": {
      "MONTH": "Monthly review",
      "YEAR": "Yearly review"
    }
  }
}
